import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Verification from "../../components/MyProfile/Verification/Index";
import LoaderOverlay from "../../reusableComponents/Loader";
import {returnErrors} from "../../store/reducers/error";
import {digiSigner, loadUser} from "../../utils/apis/user";

const Kyc = () => {
  const [activeTab, setActiveTab] = useState(0);
  const idToken = useSelector((state) => state.auth.idToken);
  const [isSingContractVisible, setIsSignContractVisible] = useState(false);
  const [kycEligible, setKycEligible] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);

  useEffect(() => {
    loadUser(idToken).then((res) => {
      setLoading(true);
      res?.data?.issue_contract ? setIsSignContractVisible(true) : setIsSignContractVisible(false);
      res?.data?.kyc_eligiblity ? setKycEligible(true) : setKycEligible(false);
      setLoading(false);
    });
  }, []);
  const dispatch = useDispatch();
  const handleSignContract = async () => {
    setLoading(true);
    const response = await digiSigner(idToken);
    if (response?.status < 399) {
      window.location.replace(response?.data?.url);
      // setLoading(false)
    } else {
      dispatch(returnErrors("Something went wrong", 500));
      setLoading(false);
    }
  };

  const items = [
    {
      name: "General Information",
      path: "general-information",
    },
    {
      name: "Verification",
      path: "verification",
    },
    {
      name: "Billing",
      path: "billing",
    },
    // {
    //   name: "Payout",
    //   path: "payout",
    // },
  ];
  return (
    <>
      {loading && <LoaderOverlay />}
      <div className="verificationCompContainer">
        <Verification kycEligible={kycEligible} />
      </div>
    </>
  );
};

export default Kyc;
